import React from 'react';

const Prism = (props) => {
    //extra columns are for scroll effect
    let num = props.numCol * (2 + props.numRow);
    let innerDivs = [];
    for (let i = 0; i <= num; i++){
        innerDivs.push(<div key={i} className={`tile-${i}`}></div>);
    }
    return (
        <div id="scales" className="hideOverflow">
            <div className="frameOverlay"></div> 
            {innerDivs} 
        </div> 
    )
}

export default Prism;